import { render, staticRenderFns } from "./PublicProjectBuildings.vue?vue&type=template&id=2d9c0977&"
import script from "./PublicProjectBuildings.vue?vue&type=script&lang=js&"
export * from "./PublicProjectBuildings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports